import styled from 'styled-components';

export const StyledLabel = styled.div`
  border-radius: 2px;
  background: ${props => props.theme.COLORS.bg};
  padding: 2px 8px;
`;
